//import {CodeBlock, CopyBlock, dracula} from "react-code-blocks";
import $ from "jquery";
import { loginAndSubmit } from "../../js/script";
import { useNavigate } from "react-router-dom";
import { setSchedule } from "../../js/database";
import { setLocalSchedule } from "../../js/localDB";
function AddSchedule({user, windowWidth}) {
    const navigate = useNavigate();


    var grabber = `
    courses = document.getElementById("coursesContainer");

    out = []
    for (let c = 0; c < courses.children.length; c++) {
        try {
        o = [courses.children[c].getElementsByTagName("h3")[0].innerText, courses.children[c].getElementsByClassName("group-owner-name")[0].innerText, courses.children[c].getElementsByTagName("h5")[0].innerText.split(" |")[0]]
        out.splice(out.length, 0, o);
        } catch(err) {
          //pass
        }
    }
    console.log(JSON.stringify(out))
`
    return (<div class="modal fade" id="setSchedule" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content bg-dark">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Setup WIT&SKILLDULE</h5>
        </div>
        {windowWidth > 1337 ?
        <div class="modal-body">
  
          <p>To get your classes, copy the code using the button below, then go to the <a href="https://fwparker.myschoolapp.com/app/student#studentmyday/progress" target="_blank">Progress page of the  Portal</a>, open the console(CMD-OPT-J on Mac, CTRL-SHIFT-J on Windows), then paste (the code) and hit return. Copy the output from the console to the textbox below and click submit.</p>
  
  <div class="text-center codeBtn"><button class="btn btn-primary" onClick={() => {
  
  try {
    navigator.clipboard.writeText(grabber).then(function() {
      document.getElementById("copyCode").innerText = "Copied!"
      document.getElementById("copyCode").classList.remove("btn-primary")
      document.getElementById("copyCode").classList.add("btn-success")
    }, function(err) {
      console.error("Async: Could not copy text ", err);;
    })
  } catch (err) {
    document.getElementById("code").classList.remove("hidden")
  }
  }
  } id="copyCode">Copy Code</button></div>
  <div id="code" class="hidden pt-4" style={{display:"none"}}>
  <p>Select and copy this code:</p>
    {/* <CodeBlock id="grabber" text={grabber} language="javascript" showLineNumbers={true} wrapLines={false} theme={dracula} codeBlock></CodeBlock> */}
  </div>
          <div class="form-group mb-3 ml-3 mr-3">
    <label for="exampleFormControlTextarea1" class="form-label">Paste Output Here</label>
    <textarea class="form-control" name="classes" id="setScheduleTextArea" rows="3" required></textarea>
  </div>{user === null || !user.hasOwnProperty("uid"
  ) ? <div class="form-group mb-3 ms-3 me-3">
        
        <button class="btn btn-primary" data-bs-dismiss="modal" onClick={() => {
            loginAndSubmit($("#setScheduleTextArea").val()).then(() => {
                navigate(0)
            })
        }}>Login</button> 
        
        <button class="btn btn-secondary ms-2" data-bs-dismiss="modal" onClick={() => {
          setLocalSchedule($("#setScheduleTextArea").val())
          navigate(0)
        }}>Continue w/o Account </button>
        </div> : <div class="form-group mb-3 ms-3 me-3">
        <button class="btn btn-primary" data-bs-dismiss="modal" onClick={() => {
            setSchedule(user, $("#setScheduleTextArea").val()).then(() => {
                navigate(0)
            })
            
        }}>Submit</button>
        </div>}
        <p><b>NEW in v4.0:</b> By logging in, you can access your schedule across devices without additonal setup. <br/> Additionally, regardless of account, you can copy your schedule to a phone by clicking copy schedule from the dropdown after you finish setup. View Lunches, MXes and Homework by clicking the associated blocks.</p>
    </div> :
    <div class="modal-body">
      <p>Setup must be preformed on a computer. If you are on a computer expand your browser.</p>
    </div>}
  </div>
  </div>
  </div>)

}

export default AddSchedule;